export * from './src/ngxerror.directive';
export * from './src/ngxerrors.directive';
export * from './src/ngxerrors.module';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// /Users/dominik/Documents/projekty/guru-apps-saas/~/@ultimate/ngxerrors/index.js
// module id = ../../../../@ultimate/ngxerrors/index.js
// module chunks = 4